import { RenderHTMLText } from '@components/common/WYSIWYG/RenderHTMLText';
import { ReactElement } from 'react';
import { PrContentProps } from './PrContent.types';

export const PrContent = ({ content }: PrContentProps): ReactElement => {
  return (
    <>
      <RenderHTMLText wysiwygData={content} />
    </>
  );
};
